export default "<app-management-header></app-management-header>\r\n<div role=\"main\" class=\"\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"